/**
 * Ordinea coloanelor instructorilor in calendar.
 * Sursa unica: campul `order` de pe Instructor (string).
 */

export function parseInstructorOrderValue(value) {
   const src = String(value ?? "").trim();
   if (!src) return Number.POSITIVE_INFINITY;

   const plain = src.match(/^(\d+)$/);
   if (plain) {
      const n = Number.parseInt(plain[1], 10);
      return Number.isFinite(n) && n > 0 ? n : Number.POSITIVE_INFINITY;
   }

   const legacy = src.match(/^(\d+)\s*[xX]/);
   if (legacy) {
      const n = Number.parseInt(legacy[1], 10);
      return Number.isFinite(n) && n > 0 ? n : Number.POSITIVE_INFINITY;
   }

   const leading = src.match(/^(\d+)/);
   if (leading) {
      const n = Number.parseInt(leading[1], 10);
      return Number.isFinite(n) && n > 0 ? n : Number.POSITIVE_INFINITY;
   }

   return Number.POSITIVE_INFINITY;
}

export function formatInstructorOrderForSave(position) {
   const n = Math.max(1, Math.trunc(Number(position)));
   return Number.isFinite(n) ? String(n) : "1";
}

export function readInstructorOrderRaw(inst) {
   if (!inst || typeof inst !== "object") return "";
   return String(inst?.order ?? "").trim();
}
